import { RatingRemarkComponent } from './../../components/rating-remark/rating-remark.component';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SuppliesOrders } from '../../models/supplies-orders';
import { GetSupplierOrderByPkService } from '../../services/get-supplier-order-by-pk.service';
import { MatDialog } from '@angular/material/dialog';
import { CancelOrderComponent } from '../../components/cancel-order/cancel-order.component';
import { CancelOrderItemComponent } from '../../components/cancel-order-item/cancel-order-item.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { GetReviewCheckService } from '../../services/get-review-check.service';
import { SupplyRequestComponent } from '../../components/supply-request/supply-request.component';
@Component({
  selector: 'app-orders-details',
  templateUrl: './orders-details.component.html',
  styleUrls: ['./orders-details.component.scss'],
  animations: [
    trigger("openCloseStatus", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '160px', opacity: '1' })),
      transition("false <=> true", [animate(500)])
    ]),
    trigger('readCloseStatus', [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '70px', opacity: '1' })),
      transition('false <=> true', [animate(500)])
    ])
  ],
})
export class OrdersDetailsComponent implements OnInit {
  oldSupplyOrder: SuppliesOrders;
  openStatus = false;
  readStatus = false;
  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private getSupplierOrderByPkService: GetSupplierOrderByPkService,
    private getReviewCheckService: GetReviewCheckService
  ) { }
  ngOnInit(): void {
    if (this.route.snapshot.data && this.route.snapshot.data.oldSupplierOrder) {
      this.oldSupplyOrder = this.route.snapshot.data.oldSupplierOrder;
      console.log(this.oldSupplyOrder);
      this.getLatestOrderData();
    }
  }
  cancelOrder() {
    const dialogRef = this.dialog.open(CancelOrderComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      data: this.oldSupplyOrder
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.getLatestOrderData();
      }
    })
  }
  getLatestOrderData() {
    this.getSupplierOrderByPkService.getSuppliesOrdersByPkSubscription(this.oldSupplyOrder.id).subscribe(data => {
      this.oldSupplyOrder = data;
    })
  }
  sendRatingReviewDialog(orderItem: any) {
    const dialogRef = this.dialog.open(RatingRemarkComponent, {
      width: '50%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: orderItem
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.getLatestOrderData();
      }
    })
  }
  cancelOrderOrderItemDialog(item_id: string) {
    const dialogRef = this.dialog.open(CancelOrderItemComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: { item_id, supplies_order_id: this.oldSupplyOrder.id }
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.getLatestOrderData();
      }
    })
  }
  supportRequestDialog() {
    const dialogRef = this.dialog.open(SupplyRequestComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      data: this.oldSupplyOrder
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.getLatestOrderData();
      }
    })
  }
  filterToggleStatus(): void {
    this.openStatus = !this.openStatus;
  }
  getReviewCheck(supply_id: string, supply_variant_id: string) {
    return this.getReviewCheckService.getSupplyReviewCount(supply_id, supply_variant_id)
  }
  readToggleStatus(): void {
    this.readStatus = !this.readStatus;
  }

  viewInvoice(){
    window.open(`https://dental-360.herokuapp.com/api/v1/event/get-invoice/${this.oldSupplyOrder.id}`);
  }
}
